export const shallowCopy = function (value) {
    return JSON.parse(JSON.stringify(value));
}

export const validateModifier = (value) => { return ["primary", "secondary", "success", "warning", "danger"].includes(value); }